import axios from 'axios';

// initial state
const state = {
  // taskTypesList:[],
  // teams:[],
  team:[],
}
const getters = {
  // teams: (state) => {
  //     return state.teams;
  //   },
    // taskTypesList: (state) => {
    //   return state.taskTypesList;
    // },
  team: (state) => {
    return state.team;
  },
}
const mutations = {
  // SET_TEAMS(state, teams) {
  //   state.teams = teams;
  // },
  // SET_TYPES(state, taskTypesList) {
  //   state.taskTypesList = taskTypesList;
  // },
  SET_TEAM(state, team) {
    state.team = team;
  },
}
const actions = {
  async getAll({commit, dispatch},){
    return axios.get("/common/team/all").then((response) => {
      // commit('SET_TEAMS',response.data.posts);
      dispatch('persist/SET_TEAMS', response.data.posts, { root: true });

      return response.data.posts;
    });
  },
  async getAllType({commit,dispatch},){
    return axios.get("/common/team/alltype").then((response) => {
      // commit('SET_TYPES',response.data.types);

      dispatch('persist/SET_TYPES', response.data.types, { root: true });

      return response.data.types;
    });
  },

}
 
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }